<div class="team-modal position-relative mt-3">
  <img src="assets/svg/close.svg"
    (click)="closeModal(false)"
    alt="remove"
    class="remove-icon cursor-pointer"/>
    <div class="d-flex flex-column align-items-center justify-content-center">
      <div class="team-header mb-3">Edit Team</div>
      <div>
        <div [style.background-image]="'url('+image+')'"
          alt="image"
          class="position-relative img d-flex align-items-end justify-content-center">
          @if (image) {
            <div class="image-cover position-absolute d-flex justify-content-center mt-2"
              >
              <div class="d-flex justify-content-center align-items-center cursor-pointer" (click)="deleteImage()">
                <mat-icon color="white">delete</mat-icon>
                <span>Delete Image</span>
              </div>
            </div>
          }
        </div>
      </div>
      <div class="d-flex justify-content-center align-items-center"></div>
      <mat-form-field class="mat-panel-title my-1 mt-4"
        (keydown.space)="stopPropagation($event)"
        (click)="stopPropagation($event)">
        <input matInput
          type="text"
          [disabled]="gameService.gameFinished.value"
          [formControl]="data.teamControl.get('team_name')"
          maxlength="30"/>
          <mat-error [hidden]="!data.teamControl.get('team_name').hasError('required')">
            This field is required
          </mat-error>
          <mat-error [hidden]="!data.teamControl.get('team_name').hasError('minLength')">
            This field must contain at least 2 characters
          </mat-error>
          <mat-error [hidden]="!data.teamControl.get('team_name').hasError('maxlength')">
            This field must contain maximum 30 characters
          </mat-error>
        </mat-form-field>
        <mat-form-field class="mat-panel-title my-1 mt-4"
          (keydown.space)="stopPropagation($event)"
          (click)="stopPropagation($event)">
          <input matInput
            type="number"
            [disabled]="gameService.gameFinished.value"
            [formControl]="data.teamControl.get('player_numbers_survey')"
            maxlength="5"/>
            <mat-error [hidden]="!data.teamControl.get('player_numbers_survey').hasError('required')">
              This field is required
            </mat-error>
          </mat-form-field>
          <button mat-button
            (click)="closeModal(true)"
            class="button-primary">
            Save
          </button>
        </div>
      </div>
